import { defineComponent, PropType } from "vue";
import { Container } from "aurelia-dependency-injection";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import moment from "moment";

import { IGetSupplyByName, IPatientSupply } from "../../../../../../resources-vue/vue-interfaces/i-get-supply";
import { formatDate, formatDateInput } from "../../../../../../common/vue-helpers/modifiers/value-modifier";
import { ToastrService } from "../../../../../../services/toastr.service";

import TablePrompt from "../../../../../../resources-vue/vue-custom-elements/TablePrompt/TablePrompt.vue";
import DatePicker from "../../../../../../resources-vue/vue-custom-elements/DatePicker/DatePicker.vue";

export default defineComponent({
    components: {
        TablePrompt,
        DatePicker
    },
    props: {
        supply: {
            type: Object,
            default: {} as IPatientSupply
        },
        updateSupply: {
            type: Function
        },
        cancelNewSupply: {
            type: Function
        },
        deleteSupplyFromList: {
            type: Function
        },
        isNewSupply: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isEditRequested: false,
            isDeleteRequested: false,
            cacheSupply: null,
            _toastrService: null,
            formatDate,
            formatDateInput,
            v$: useVuelidate()
        };
    },
    validations() {
        return {
            supply: {
                startDate: { required }
            }
        };
    },
    created() {
        this._toastrService = Container.instance.get(ToastrService);
    },
    computed: {
        isSupplyFormularyBoolean() {
            return typeof this.supply.isFormulary === "boolean";
        },
        isSupplyIsRelatedBoolean() {
            return typeof this.supply.isRelated === "boolean";
        }
    },
    methods: {
        onDateChange(date: any, name: string) {
            if (name === "supplyStartDate") this.supply.startDate = date;
            if (name === "supplyEndDate") this.supply.endDate = date;
        },
        editSupply() {
            this.isEditRequested = true;
            this.cacheSupply = Object.assign({}, this.supply);
        },
        requestDeleteSupply() {
            this.isDeleteRequested = true;
        },
        async saveEdit() {
            const validated = await this.v$.$validate();
            if (!validated) {
                return;
            }
            if (!this.supply.startDate) {
                this._toastrService.error({
                    title: `Start Date Required`,
                    message: `The Start Date is required for a Supply. Please update and try again.`
                });
                return;
            } else if (moment(this.supply.startDate) > moment(this.supply.endDate)) {
                this._toastrService.error({
                    title: `Error`,
                    message: `The End Date cannot be before Start Date. Please update and try again.`
                });
                return;
            }
            this.updateSupply({ newSupply: this.supply, oldSupply: this.cacheSupply });
            this.isEditRequested = false;
        },
        cancelEdit() {
            if (this.isNewSupply) {
                this.cancelNewSupply();
            } else {
                this.updateSupply(JSON.parse(JSON.stringify(this.cacheSupply)), this.supply);
                this.isEditRequested = false;
            }
        },
        deleteSupply() {
            this.deleteSupplyFromList(this.supply);
            this.isDeleteRequested = false;
        },
        cancelDelete() {
            this.isDeleteRequested = false;
        }
    }
});
